import { SB } from '@play-co/replicant';

const match2RewardSchema = {
  type: SB.string(),
  subType: SB.string().optional(),
  amount: SB.int().optional().default(0),
  duration: SB.int().optional().default(0),
};

export default {
  admin: SB.array(
    SB.object({
      coins: SB.int().optional(),
      freeGems: SB.int().optional(),
      previousPetName: SB.string().optional(),
      newPetName: SB.string().optional(),
      allowEditor: SB.boolean().optional().default(false),
      resetPetNegativeEffects: SB.boolean().optional().default(false),

      match2Consumables: SB.object(match2RewardSchema).optional(),
      battlePass: SB.boolean().optional().default(false),
      superLollipopStreak: SB.int().optional(),
      /** @deprecated Fairy Forest removed (#11760); kept for state compatibility. */
      fairyForestBalls: SB.int().optional(),

      // Sale pack grant - for granting complete sale packs via CS Tool
      salePack: SB.object({
        productId: SB.string(),
        paidGems: SB.int().optional().default(0),
        freeGems: SB.int().optional().default(0),
        setStarterPackPurchased: SB.boolean().optional().default(false),
        setPetStarterPackPurchased: SB.boolean().optional().default(false),
      }).optional(),
      bundleSalePack: SB.object({
        paidProductId: SB.string(),
        reimbursableProductIds: SB.array(SB.string()),
        paidGems: SB.int().optional().default(0),
        freeGems: SB.int().optional().default(0),
      }).optional(),

      reason: SB.string(),
      claimed: SB.boolean(),

      timestamp: SB.int().min(0),
    }),
  ),
};
